import React from "react";
import { useSelector } from "react-redux";

// CSS mirrors travel-qr Header.jsx exactly
const HEADER_CSS = `
  .tvh-wrapper { background-color:#F6E9FF; }
  @media (min-width:1024px) { .tvh-wrapper { background-color:transparent; } }

  .tvh-header {
    background:white; border-bottom:1px solid #F0EEF5;
    position:relative; z-index:10; border-radius:0 0 24px 24px;
  }
  @media (min-width:1024px) {
    .tvh-header { box-shadow:0 2px 8px rgba(0,0,0,0.08); border-radius:0; }
  }

  .tvh-inner {
    width:100%; padding:12px 20px; box-sizing:border-box;
    display:flex; align-items:center; justify-content:center;
  }
  @media (min-width:1024px) {
    .tvh-inner { padding:12px 40px; justify-content:space-between; }
  }

  .tvh-logo { width:110px; height:68px; }
  @media (min-width:1024px) { .tvh-logo { width:140px; height:68px; } }

  .tvh-partner {
    display:flex; align-items:center; gap:8px;
    border-left:1px solid #E0E0E0; padding-left:20px; margin-left:20px;
  }
  @media (min-width:1024px) {
    .tvh-partner { border-left:none; padding-left:0; margin-left:0; gap:12px; }
  }

  /* Partner name text — hidden on mobile, visible on desktop */
  .tvh-partner-name {
    font-family:'Gilroy',-apple-system,Roboto,Helvetica,sans-serif;
    font-size:12px; font-weight:400; color:#282828; display:none;
  }
  @media (min-width:1024px) { .tvh-partner-name { display:block; font-size:16px; } }

  .tvh-logo-img { width:36px; height:36px; border-radius:50%; object-fit:cover; }
  @media (min-width:1024px) { .tvh-logo-img { width:44px; height:44px; } }
`;

export default function TravelHeader() {
  const merchantDetail = useSelector((state) => state.auth.merchantDetails);
  const travelPartnerName = merchantDetail?.displayName || "";
  const travelPartnerLogo = merchantDetail?.merchantSmallImage || null;

  return (
    <>
      <style>{HEADER_CSS}</style>
      <div className="tvh-wrapper">
        <header className="tvh-header">
          <div className="tvh-inner">
            <img
              src="/assets/FibeEMIS.svg"
              alt="FibeEMIS"
              className="tvh-logo"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
            <div className="tvh-partner">
              <span className="tvh-partner-name">
                Travel partner :{" "}
                <span style={{ fontWeight: 400, color: "#282828" }}>{travelPartnerName}</span>
              </span>
              {travelPartnerLogo && (
                <img src={travelPartnerLogo} alt={travelPartnerName} className="tvh-logo-img" />
              )}
            </div>
          </div>
        </header>
      </div>
    </>
  );
}
